module.exports = __webpack_public_path__ + "SourceSansPro-BlackItalic.8cd9665326fbcf836a8f.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-BlackItalic.woff2
// module id = ../../../../../src/assets/customfonts/SourceSansPro-BlackItalic.woff2
// module chunks = styles